import type { IDexfSettings, ILocalizedInformation } from '@inter-ikea-kompis/types';

/**
 *
 */
export default class DexfSettingsUtility {
	/**
	 * Parses localized information object from Översätta to DEXF settings object.
	 *
	 * @param localizedInformation Localized information to parse.
	 * @returns Parsed IDexfSettings object.
	 */
	public static parseLocalizedInformation(
		localizedInformation: ILocalizedInformation
	): IDexfSettings {
		const parsedSettings: IDexfSettings = {
			kompis: {
				endpoints: localizedInformation.endpoints,
				localization: {
					...localizedInformation.localization,
					abTest: localizedInformation.userABTest?.ordnaTeam
				},
				serviceSettings: localizedInformation.localization,
				urls: localizedInformation.urls,
				priceSettings: localizedInformation.priceSettings
			},
			localisation: {
				// localization
				useMetricMeasures: localizedInformation.localization.useMetricMeasures,
				usesSubDomain: localizedInformation.localization.usesSubDomain,
				dateFormat: localizedInformation.localization.dateFormat,
				alternateLanguages: localizedInformation.localization.alternateLanguages,
				writeDirection: localizedInformation.localization.writeDirection,
				// priceSettings
				decimalSeparator: localizedInformation.priceSettings.decimalSeparator,
				currencySymbol: localizedInformation.priceSettings.currencySymbol,
				noValueDecimalsString: localizedInformation.priceSettings.noValueDecimalsString,
				thousandSeparatorEnabled: localizedInformation.priceSettings.thousandSeparatorEnabled,
				currencyPosition: localizedInformation.priceSettings.currencyPosition,
				symbolSpacing: localizedInformation.priceSettings.symbolSpacing,
				thousandSeparator: localizedInformation.priceSettings.thousandSeparator,
				replaceNoValueDecimals: localizedInformation.priceSettings.replaceNoValueDecimals,
				numberOfDecimals: localizedInformation.priceSettings.numberOfDecimals,
				currencyCode: localizedInformation.priceSettings.currencyCode
			}
		};

		return parsedSettings;
	}
}
